<template>
	<div class="omapi-card__flex omapi-dash__announcements">
		<common-card class="omapi-dash__announcements" title="Announcements">
			<core-loading v-if="isLoading"></core-loading>
			<div v-else>
				<ul class="omapi-detailed-list">
					<li v-for="announcement in announcements" :key="announcement.id">
						<div class="omapi-multi-column__primary">
							<div class="omapi-multi-column__primary">
								<div class="omapi-multi-column__title">
									<a
										:href="announcement.link"
										target="_blank"
										rel="noopener"
										class="omapi-link-title"
									>
										{{ announcement.title }}
									</a>
								</div>
								<div class="omapi-multi-column__secondary">
									{{ announcement.date }}
								</div>
							</div>
							<div class="omapi-multi-column__text">
								{{ announcement.excerpt }}
							</div>
							<div class="omapi-multi-column__buttons">
								<core-button
									:href="announcement.link"
									target="_blank"
									rel="noopener"
									type="secondary"
									size="small"
								>
									Learn More
								</core-button>
								<core-upgrade-button
									v-if="showUpsell && connected"
									utm-medium="DashboardAnnouncementsWidget"
									target="_blank"
									type="secondary"
									size="small"
								>
									Get Optinmonster {{ upsellToShow }}
								</core-upgrade-button>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<template #footer>
				<a :href="viewAllUrl" target="_blank" rel="noopener" class="omapi-link-arrow-after">
					More announcements
				</a>
			</template>
		</common-card>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: {
		upsellToShow: {
			type: String,
			default: 'none',
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		announcements: {
			type: Array,
			required: true,
		},
	},
	computed: {
		...mapGetters(['connected']),
		showUpsell() {
			return 'none' !== this.upsellToShow;
		},
		viewAllUrl() {
			return this.$urls.marketing('press/press-room/');
		},
	},
};
</script>
